import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const STARS = ["⭐", "🌟", "💫", "✨"];

export function TwinklingStars({ count = 40 }: EffectProps = {}) {
  const stars = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        char: pick(STARS),
        left: `${rand(0, 100)}vw`,
        top: `${rand(0, 100)}vh`,
        size: `${rand(18, 44)}px`,
        twinkleDuration: `${rand(2.2, 4.5)}s`,
        delay: `${rand(-4, 0)}s`,
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {stars.map(s => (
        <span
          key={s.id}
          className="fx-particle fx-bigstar"
          style={
            {
              left: s.left,
              top: s.top,
              fontSize: s.size,
              animationDuration: s.twinkleDuration,
              animationDelay: s.delay,
            } as CSSProperties
          }
        >
          {s.char}
        </span>
      ))}
    </div>
  );
}
